/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RepairPlanTask } from '../models';
/**
 * RepairPlanTaskApi - axios parameter creator
 * @export
 */
export const RepairPlanTaskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get repairPlanTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/repairPlanTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the repairPlanTask by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanTasksIdDelete', 'id', id)
            const localVarPath = `/repairPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the repairPlanTask by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanTasksIdGet', 'id', id)
            const localVarPath = `/repairPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific repairPlanTask
         * @param {number} id 
         * @param {RepairPlanTask} [repairPlanTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksIdPut: async (id: number, repairPlanTask?: RepairPlanTask, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairPlanTasksIdPut', 'id', id)
            const localVarPath = `/repairPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlanTask, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post repairPlanTask
         * @param {RepairPlanTask} [repairPlanTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksPost: async (repairPlanTask?: RepairPlanTask, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/repairPlanTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairPlanTask, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairPlanTaskApi - functional programming interface
 * @export
 */
export const RepairPlanTaskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairPlanTaskApiAxiosParamCreator(configuration)
    return {
        /**
         * Get repairPlanTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanTasksGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanTasksGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the repairPlanTask by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanTasksIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanTasksIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the repairPlanTask by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanTasksIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanTasksIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific repairPlanTask
         * @param {number} id 
         * @param {RepairPlanTask} [repairPlanTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanTasksIdPut(id: number, repairPlanTask?: RepairPlanTask, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanTasksIdPut(id, repairPlanTask, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post repairPlanTask
         * @param {RepairPlanTask} [repairPlanTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairPlanTasksPost(repairPlanTask?: RepairPlanTask, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairPlanTasksPost(repairPlanTask, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RepairPlanTaskApi - factory interface
 * @export
 */
export const RepairPlanTaskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairPlanTaskApiFp(configuration)
    return {
        /**
         * Get repairPlanTask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksGet(options?: any): AxiosPromise<RepairPlanTask> {
            return localVarFp.repairPlanTasksGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the repairPlanTask by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.repairPlanTasksIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the repairPlanTask by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksIdGet(id: number, options?: any): AxiosPromise<RepairPlanTask> {
            return localVarFp.repairPlanTasksIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific repairPlanTask
         * @param {number} id 
         * @param {RepairPlanTask} [repairPlanTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksIdPut(id: number, repairPlanTask?: RepairPlanTask, options?: any): AxiosPromise<RepairPlanTask> {
            return localVarFp.repairPlanTasksIdPut(id, repairPlanTask, options).then((request) => request(axios, basePath));
        },
        /**
         * Post repairPlanTask
         * @param {RepairPlanTask} [repairPlanTask] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairPlanTasksPost(repairPlanTask?: RepairPlanTask, options?: any): AxiosPromise<RepairPlanTask> {
            return localVarFp.repairPlanTasksPost(repairPlanTask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RepairPlanTaskApi - object-oriented interface
 * @export
 * @class RepairPlanTaskApi
 * @extends {BaseAPI}
 */
export class RepairPlanTaskApi extends BaseAPI {
    /**
     * Get repairPlanTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairPlanTaskApi
     */
    public repairPlanTasksGet(options?: AxiosRequestConfig) {
        return RepairPlanTaskApiFp(this.configuration).repairPlanTasksGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the repairPlanTask by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairPlanTaskApi
     */
    public repairPlanTasksIdDelete(id: number, options?: AxiosRequestConfig) {
        return RepairPlanTaskApiFp(this.configuration).repairPlanTasksIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the repairPlanTask by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairPlanTaskApi
     */
    public repairPlanTasksIdGet(id: number, options?: AxiosRequestConfig) {
        return RepairPlanTaskApiFp(this.configuration).repairPlanTasksIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific repairPlanTask
     * @param {number} id 
     * @param {RepairPlanTask} [repairPlanTask] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairPlanTaskApi
     */
    public repairPlanTasksIdPut(id: number, repairPlanTask?: RepairPlanTask, options?: AxiosRequestConfig) {
        return RepairPlanTaskApiFp(this.configuration).repairPlanTasksIdPut(id, repairPlanTask, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post repairPlanTask
     * @param {RepairPlanTask} [repairPlanTask] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairPlanTaskApi
     */
    public repairPlanTasksPost(repairPlanTask?: RepairPlanTask, options?: AxiosRequestConfig) {
        return RepairPlanTaskApiFp(this.configuration).repairPlanTasksPost(repairPlanTask, options).then((request) => request(this.axios, this.basePath));
    }
}
